module.exports = __webpack_public_path__ + "static/media/WWF_logo.2ea2405d.png";